/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Photos_Input_RemoveInputs */

const en_admin_resources_photos_input_remove = /** @type {(inputs: Admin_Resources_Photos_Input_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const de_admin_resources_photos_input_remove = /** @type {(inputs: Admin_Resources_Photos_Input_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen`)
};

const es_admin_resources_photos_input_remove = /** @type {(inputs: Admin_Resources_Photos_Input_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const fr_admin_resources_photos_input_remove = /** @type {(inputs: Admin_Resources_Photos_Input_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

const nl_admin_resources_photos_input_remove = /** @type {(inputs: Admin_Resources_Photos_Input_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijderen`)
};

/** @type {(inputs: Admin_Resources_Photos_Input_RemoveInputs) => LocalizedString} */
const it_admin_resources_photos_input_remove = en_admin_resources_photos_input_remove;

/** @type {(inputs: Admin_Resources_Photos_Input_RemoveInputs) => LocalizedString} */
const pt_br2_admin_resources_photos_input_remove = en_admin_resources_photos_input_remove;

/** @type {(inputs: Admin_Resources_Photos_Input_RemoveInputs) => LocalizedString} */
const pl_admin_resources_photos_input_remove = en_admin_resources_photos_input_remove;

/** @type {(inputs: Admin_Resources_Photos_Input_RemoveInputs) => LocalizedString} */
const hu_admin_resources_photos_input_remove = en_admin_resources_photos_input_remove;

/** @type {(inputs: Admin_Resources_Photos_Input_RemoveInputs) => LocalizedString} */
const ro_admin_resources_photos_input_remove = en_admin_resources_photos_input_remove;

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Admin_Resources_Photos_Input_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_photos_input_remove = /** @type {((inputs?: Admin_Resources_Photos_Input_RemoveInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Photos_Input_RemoveInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_photos_input_remove(inputs)
	if (locale === "de") return de_admin_resources_photos_input_remove(inputs)
	if (locale === "es") return es_admin_resources_photos_input_remove(inputs)
	if (locale === "fr") return fr_admin_resources_photos_input_remove(inputs)
	if (locale === "nl") return nl_admin_resources_photos_input_remove(inputs)
	if (locale === "it") return it_admin_resources_photos_input_remove(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_photos_input_remove(inputs)
	if (locale === "pl") return pl_admin_resources_photos_input_remove(inputs)
	if (locale === "hu") return hu_admin_resources_photos_input_remove(inputs)
	return ro_admin_resources_photos_input_remove(inputs)
});
export { admin_resources_photos_input_remove as "admin.resources.photos_input.remove" }